import { erpAxios } from '.';

const statusOdbijenRazlog = async (data) => {
  const res = await erpAxios.post(`/statusOdbijen/setRazlog`, data);
  return res;
};

export default statusOdbijenRazlog;
